import { Component, inject, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NgUpperFirstPipeModule } from '@z-trippete/angular-pipes';
import {
  IMPERSONATE_USER_ID,
  ORGANIZATION_SELECTED,
} from '@booking-booster-client/helpers';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'bb-logout',
  imports: [TranslateModule, NgUpperFirstPipeModule],
  templateUrl: './logout.component.html',
  styleUrl: './logout.component.css',
})
export class LogoutComponent implements OnInit {
  private authService = inject(AuthService);

  cookiePatterns = [/token/, /oauth_state/, /oidc/];
  storagePatterns = [
    /id_token/,
    /access_token/,
    /refresh_token/,
    /state/,
    /nonce/,
    new RegExp(IMPERSONATE_USER_ID),
    new RegExp(ORGANIZATION_SELECTED),
  ];

  ngOnInit(): void {
    this.clearSpecificCookies();
    this.clearSpecificSessionStorage();
    this.clearSpecificLocalStorage();

    setTimeout(() => {
      this.authService.initializeAuthState();
    }, 500);
  }

  // Clear specific cookies related to OAuth2
  clearSpecificCookies() {
    const cookies = document.cookie.split('; ');
    for (const cookie of cookies) {
      const [name] = cookie.split('=');
      if (this.cookiePatterns.some((pattern) => pattern.test(name))) {
        document.cookie = `${name}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
        document.cookie = `${name}=; path=/; domain=${location.hostname}; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
      }
    }
  }

  // Clear specific session storage items related to OAuth2
  clearSpecificSessionStorage() {
    for (const key of Object.keys(sessionStorage)) {
      if (this.storagePatterns.some((pattern) => pattern.test(key))) {
        sessionStorage.removeItem(key);
      }
    }
  }

  // Clear specific local storage items related to OAuth2
  clearSpecificLocalStorage() {
    for (const key of Object.keys(localStorage)) {
      if (this.storagePatterns.some((pattern) => pattern.test(key))) {
        localStorage.removeItem(key);
      }
    }
  }
}
